import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "podcasts__item" }
const _hoisted_2 = { class: "podcasts__img-box" }
const _hoisted_3 = {
  key: 0,
  class: "podcasts__badge"
}
const _hoisted_4 = { class: "podcasts__text-box" }
const _hoisted_5 = { class: "podcasts__title" }
const _hoisted_6 = { class: "podcasts__subtitle" }

import { IS_PRERENDERING } from '@/init/settings'
import { DocGroupListItem } from '@/models/interfaces'
import LazyImage from './LazyImage.vue'
import PublicImage from './PublicImage.vue'
import { PodcastsView } from '@/models/docs.list.podcasts'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PodcastCard',
  props: {
    doc: null,
    view: null
  },
  setup(__props: any) {



/* Lazy load is disabled for static pages.

  Note: When accessing the static page locally, we will not see any cover_images 
  unless we've build them using the build.sh script.
  
  */

const lazyComponent = computed(() => {
  return !IS_PRERENDERING ? LazyImage : PublicImage
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: __props.view.startLinkParams(__props.doc),
      class: "podcasts__link"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (__props.view.hasFollowBadge() && __props.doc.is_followed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Following"))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(lazyComponent)), {
            src: __props.doc.cover_image,
            crossorigin: "anonymous",
            class: "podcasts__img",
            alt: ""
          }, null, 8, ["src"]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.doc.title), 1),
          _createElementVNode("h4", _hoisted_6, _toDisplayString(__props.view.podcastSubtitle(__props.doc)), 1)
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})